import request from '@/utils/http'

const PREFIX = '/eventApp'

const eventAttribute = {
  listByEventId(id) {
    return request(
      `${PREFIX}/` + id,
      'get'
    )
  }
}

export default eventAttribute
